import { render, staticRenderFns } from "./ValidationForms.vue?vue&type=template&id=3e12a1bf"
import script from "./ValidationForms.vue?vue&type=script&lang=js"
export * from "./ValidationForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports